import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cafm-restructure/artifacts/o51eebue_597817161_1172388751673908_7998470242494796850_n.jpg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="CAF Patronato EPAS"
              className="h-16 w-auto mb-6 bg-white rounded-lg p-2"
            />
            <p className="text-slate-400 text-base leading-relaxed">
              Centro Assistenza Fiscale e Patronato EPAS. Ti aiutiamo con ISEE, 730, pensioni, pratiche INPS e molto altro.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg font-bold mb-6">Servizi</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/servizi" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-servizi"
                >
                  Tutti i Servizi
                </Link>
              </li>
              <li>
                <Link 
                  to="/documenti-730" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-730"
                >
                  Modello 730
                </Link>
              </li>
              <li>
                <Link 
                  to="/documenti-isee" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-isee"
                >
                  ISEE - DSU
                </Link>
              </li>
              <li>
                <Link 
                  to="/udicon" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-udicon"
                >
                  U.DI.CON
                </Link>
              </li>
              <li>
                <Link 
                  to="/prenota" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-prenota"
                >
                  Prenota Appuntamento
                </Link>
              </li>
            </ul>
          </div>

          {/* Info Links */}
          <div>
            <h3 className="font-heading text-lg font-bold mb-6">Informazioni</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/chi-siamo" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-chi-siamo"
                >
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link 
                  to="/news" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-news"
                >
                  News
                </Link>
              </li>
              <li>
                <Link 
                  to="/contatti" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-contatti"
                >
                  Contatti
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-privacy"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-lg font-bold mb-6">Contatti</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" />
                <span className="text-slate-400">
                  Corso Nunzio Ricco n° 9<br />
                  76016 Margherita di Savoia (BT)
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-red-500 flex-shrink-0" />
                <a 
                  href="tel:0883411359" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  0883 411359
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-red-500 flex-shrink-0" />
                <a 
                  href="mailto:patronatoepasmargherita@gmail.com" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-email"
                >
                  patronatoepasmargherita@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" />
                <span className="text-slate-400">
                  Lun - Ven: 09:00 - 18:00<br />
                  Pausa: 13:00 - 14:00
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} CAF & Patronato EPAS Margherita di Savoia. Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-slate-500 text-sm">Affiliato a:</span>
              <span className="text-slate-400 text-sm font-medium">CAF Italia Srl • EPAS • FNA Confsal • U.Di.Con</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
